import { useEffect, useRef } from "react";

const emailAddress = "info@throttledink.com";
const emailLink = `mailto:${emailAddress}`;

export default function Email() {
  const hasOpenedEmail = useRef(false);

  useEffect(() => {
    if (!hasOpenedEmail.current) {
      hasOpenedEmail.current = true;
      window.location.href = emailLink;
    }
  }, []);

  return (
    <main className="min-h-screen bg-black text-gray-200 dosis flex flex-col items-center justify-center px-6 pt-32 pb-16 text-center">
      <h1 className="text-4xl sm:text-5xl font-heading text-white mb-6 uppercase">
        Email Greg
      </h1>
      <p className="max-w-lg text-lg text-gray-400 mb-8">
        Your email app should open automatically. If it doesn’t, use the link
        below to email Greg.
      </p>
      <a
        href={emailLink}
        className="inline-block bg-white text-black font-semibold px-6 py-3 rounded hover:bg-gray-200 transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white"
      >
        Email Greg
      </a>
      <p className="mt-6 text-gray-400 break-all">{emailAddress}</p>
    </main>
  );
}
